module.exports = __webpack_public_path__ + "static/image/logo-family/logo_mfo.ver2_0_2.png?25c397bf";